<template>
    <div class="data-wrapper-core email-connections-wrapper">
        <h3>Email Automationen</h3>
        <v-divider></v-divider>
        <v-text-field class="email-connections-search-field" prepend-inner-icon="mdi-magnify" variant="outlined"
            density="compact" label="Suche" hide-details single-line rounded="lg" v-model="searchQuery"></v-text-field>
        <v-expansion-panels>
            <v-expansion-panel rounded="lg" v-for="emailAutomation in emailAutomations" :key="emailAutomation._id">
                <v-expansion-panel-title class="email-connections-panel-title">
                    <h4>{{ emailAutomation.name }}</h4>
                </v-expansion-panel-title>
                <v-expansion-panel-text class="email-connections-panel-text">
                    <v-list density="compact">
                        <v-divider style="margin-bottom: 12px;"></v-divider>
                        <h4>Subjekt:</h4>
                        <v-list-item>{{ emailAutomation.subject }}</v-list-item>
                        <h4>Aktiv:</h4>
                        <v-list-item>{{ emailAutomation.active }}</v-list-item>
                        <h4>Erstellt am:</h4>
                        <v-list-item>{{ emailAutomation.createdAt }}</v-list-item>
                        <div class="email-automation-data-button-wrapper">
                            <v-btn rounded="lg" class="email-automation-data-button" @click="handleShowLog"
                                variant="outlined" :append-icon="logIcon">Log:</v-btn>
                            <div v-show="showLog" class="email-automation-data-display">
                                <div v-show="showLog"
                                    v-for="(object, index) in emailAutomation.log" :key="index">
                                    <div v-for="(value, key) in object" :key="key">
                                        <h4>{{ key }}:</h4>
                                        <p>{{ value }}</p>
                                    </div>
                                </div>
                            </div>
                            <v-btn rounded="lg" class="email-automation-data-button" @click="handleShowTrigger"
                                variant="outlined" :append-icon="triggerIcon">Trigger:</v-btn>
                            <div v-show="showTrigger" class="email-automation-data-display">
                                <div v-show="showTrigger" v-for="(value, key) in emailAutomation.trigger" :key="key">
                                    <h4>{{ key }}:</h4>
                                    <p>{{ value }}</p>
                                </div>
                            </div>
                            <v-btn rounded="lg" class="email-automation-data-button" @click="handleShowSender"
                                variant="outlined" :append-icon="senderIcon">Sender:</v-btn>
                            <div v-show="showSender" class="email-automation-data-display">
                                <div v-show="showSender" v-for="(value, key) in emailAutomation.sender" :key="key">
                                    <h4>{{ key }}:</h4>
                                    <p>{{ value }}</p>
                                </div>
                            </div>
                            <v-btn rounded="lg" class="email-automation-data-button" @click="handleShowTo"
                                variant="outlined" :append-icon="toIcon">Empfänger:</v-btn>
                            <div v-show="showTo" class="email-automation-data-display">
                                <div v-show="showTo" v-for="(object, index) in emailAutomation.to" :key="index">
                                    <div v-for="(value, key) in object" :key="key">
                                        <h4>{{ key }}:</h4>
                                        <p>{{ value }}</p>
                                    </div>
                                </div>
                            </div>
                            <v-btn rounded="lg" class="email-automation-data-button" @click="handleCC"
                                variant="outlined" :append-icon="ccIcon">CC:</v-btn>
                            <div v-show="showCC" class="email-automation-data-display">
                                <div v-show="showCC" v-for="(object, index) in emailAutomation.cc" :key="index">
                                    <h4>CC-Adresse:</h4>
                                    <p>{{ object }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="email-automation-html-text">
                            <h4>HTML-Text:</h4>
                            <div v-html="emailAutomation.htmlText"></div>
                        </div>
                        <h4>__v:</h4>
                        <v-list-item>{{ emailAutomation.__v }}</v-list-item>
                    </v-list>
                </v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data() {
        return {
            searchQuery: '',
            showTrigger: false,
            showLog: false,
            showSender: false,
            showTo: false,
            showCC: false
        };
    },
    methods: {
        handleShowTrigger() {
            this.showTrigger = !this.showTrigger;
        },
        handleShowLog() {
            this.showLog = !this.showLog;
        },
        handleShowSender() {
            this.showSender = !this.showSender;
        },
        handleShowTo() {
            this.showTo = !this.showTo;
        },
        handleCC() {
            this.showCC = !this.showCC;
        }
    },
    computed: {
        ...mapState('table', ['emailAutomations']),
        triggerIcon() {
            return this.showTrigger ? 'mdi-chevron-up' : 'mdi-chevron-down';
        },
        logIcon() {
            return this.showLog ? 'mdi-chevron-up' : 'mdi-chevron-down';
        },
        senderIcon() {
            return this.showSender ? 'mdi-chevron-up' : 'mdi-chevron-down';
        },
        toIcon() {
            return this.showTo ? 'mdi-chevron-up' : 'mdi-chevron-down';
        },
        ccIcon() {
            return this.showCC ? 'mdi-chevron-up' : 'mdi-chevron-down';
        }
    }
}
</script>

<style lang="scss" scoped>
.email-automation-data-button-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 12px auto;
}

.email-automation-data-display {
    padding: 12px;
    border: 1px solid rgb(196, 196, 196);
    border-radius: 12px;
}

.email-connections-wrapper {
    max-height: 600px;
    overflow-y: auto;
}

.email-connections-search-field {
    margin: 8px 0;
}

.email-connections-panels {
    margin: 8px 0;
}
</style>